export class Certification {
  public id: number;
  public code: string;
  public description:string;
  public flg_state:string;
  public flg_kf:string;
  public flg_dpl:string;
  public user_ins_id:number;
  public ts_ins:string;
}



// WEBPACK FOOTER //
// ./src/app/models/certification.model.ts